//@import dependencies
import React, {Component} from 'react'
import {connect} from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
//@end

//@import components
import {HomeScreenLayout} from 'app_components/screens/home'
//@end

// @import events
// @end

//@import utils
//@end

//@import services
//@end

const mapStatesToProps = (state: IState) => {
  return state
}

interface IHomeScreenProps {
  history: any
}
interface IHomeScreenState {}

class HomeScreen extends Component<IHomeScreenProps, IHomeScreenState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: any) {
    super(props)
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  componentWillUnmount = () => {}

  render() {
    return(
      <HomeScreenLayout
        history={this.props.history}
      />
    )
  }
}

export default connect(mapStatesToProps)(HomeScreen)
